"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleLinkArea = exports.ModalArea = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Box = _interopRequireDefault(require("../../Box"));
var _constant = require("../../../styles/constant");
var _templateObject, _templateObject2;
const ModalArea = exports.ModalArea = (0, _styledComponents["default"])(_Modal["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: 300px;\n  width: 400px;\n"])));
const ToggleLinkArea = exports.ToggleLinkArea = (0, _styledComponents["default"])(_Box["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  justify-content: flex-end;\n  display: flex;\n  & button {\n    font-size: 14px;\n    margin-top: 16px;\n    color: ", ";\n    cursor: pointer;\n    border: 0;\n    background-color: transparent;\n  }\n"])), (0, _constant.get)('colors.primary.blue.600'));